// search.ts — the global spyglass filter above the class summary table.
//
// One input; case-insensitive substring match over each badge's name (data-cs-name, lowercased at render).
// Non-matching badges are hidden; empty cells collapse naturally. The predicate is column-agnostic, so a
// future per-column variant is a render-layer change only. Operates purely on the rendered DOM — no
// refetch, no rebuild — and is re-applied after a subclass change (index.ts threads the live term back in).

// Trailing spyglass glyph — same SVG + ft-inline-search-* classes as the catalog-list / account search
// fields (includes/search_inline_trailing_icons_inc.php), so it sits INSIDE the input and inherits the
// site's inline-search styling rather than being a separate input-group addon.
const SPYGLASS_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"'
    + ' stroke-width="2.5" stroke-linecap="round" aria-hidden="true" focusable="false"'
    + ' class="ft-inline-search-trailing-svg"><circle cx="11" cy="11" r="7"/><path d="M16 16l4.5 4.5"/></svg>';

/**
 * Compact search control, right-aligned in the gradient header bar. Mirrors the catalog-list inline
 * pattern: a position-relative root, the input with pe-5 so text clears the icon, and the spyglass glyph
 * absolutely positioned inside the field's trailing edge.
 */
export function renderSearchBoxHtml(term: string): string {
    return '<div class="ft-cs-search ft-inline-search-root position-relative" style="width:280px;max-width:60%;">'
        + '<input type="search" class="form-control form-control-sm w-100 pe-5 ft-cs-search-input"'
        + ' placeholder="Search abilities..." aria-label="Search abilities" autocomplete="off"'
        + ' value="' + escapeHtml(term) + '">'
        + '<span class="ft-inline-search-trailing position-absolute top-50 end-0 translate-middle-y me-2 d-flex align-items-center justify-content-center">'
        + '<span class="ft-inline-search-glyph" aria-hidden="true" style="line-height:0;">' + SPYGLASS_SVG + '</span>'
        + '</span>'
        + '</div>';
}

/** Hide every badge whose name does not contain `term` (case-insensitive). Empty term shows all. */
export function applySearch(container: HTMLElement, term: string): void {
    const needle = term.trim().toLowerCase();
    const badges = container.querySelectorAll<HTMLElement>('.badge[data-cs-name]');
    badges.forEach((badge) => {
        const name = badge.getAttribute('data-cs-name') || '';
        const wrap = (badge.parentElement as HTMLElement) || badge; // the <div> wrapper
        wrap.style.display = (needle === '' || name.indexOf(needle) !== -1) ? '' : 'none';
    });
}
